import currencyFormatService from '@/currency/service/currencyFormatService';

export default (value, currency, decimals) =>
  currencyFormatService.formatValue(value, currency, decimals);
